import React from 'react'; 
import {getData } from '../../../core/HttpAction';  
import Table from '../../../core/Table'; 
import {PdfGenrate} from '../../../core/Pdf';  
import {exportCSVFile,dataUri} from '../../../core/CsvDownload';  
 
const Url='/qr-code';

/* const QrCodeColumn=({row,index})=>{  
    return row.url?<img style={{width:'50px',height:'50px'}} src={row.url} alt="QR Code"/>:''; 
};  */

const CustomButton=({props})=>{   
    return<button style={{float:'left'}} type="button" onClick={()=>props.download()}   className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Download CSV</button>;
}; 

const CustomAction=({props})=>{    
    return <select className="md-input" onChange={(e)=>props.custonAction(e)} style={{width:'125px',float: 'left', marginRight:'8px'}} > 
        <option value="book">Book</option>  
        <option value="student">Student</option> 
        <option value="staff">Staff</option> 
    </select>;
}; 
 
const columns=[
   
    {
        key:'code',
        displayName:'ID',
        styles:{width:'20%'}
    },
    {
        key:'name',
        displayName:'Name',
        styles:{width:'75%'}
    },
    /* {
        key:'url',
        displayName:'QR Code',
        Cell:QrCodeColumn
    } */ 
     
];

class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'',  
                type:'book'
            }, 
            data:[],
            pdfData:[],
            preloader:true
        }; 
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData=()=>{
        getData(Url,this.state.params).then((res)=>{ 
            let data=res.data;
            /*  if(data)
                this.make_base(data); */
            this.setState({data:data,preloader:false}); 
        });
    }

    handleFetch=(params)=>{
        this.setState({params:{...this.state.params,...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    download=()=>{
        const fileName ='qr-code';
        const {data}=this.state.data;
        var valStudent = false;
        const rows=data.map((val,i)=>{
            if(val.category) {
                return{
                    code:val.code,
                    title:val.name,
                    category:val.category,
                    author:val.author,
                    qr_code:val.qr_code,  
                };
            } else {
                valStudent = true;
                return{
                    code:val.code,
                    title:val.name,
                    qr_code:val.qr_code,  
                };
            }
        }); 
        let headers={};
        if(valStudent) {
            headers = {
                code: 'Code'.replace(/,/g, ''),
                title: 'Title'.replace(/,/g, ''), 
                qr_code: 'QR Code', 
            };
        } else {
            headers = {
                code: 'Code'.replace(/,/g, ''),
                title: 'Title'.replace(/,/g, ''), 
                category: 'Category'.replace(/,/g, ''),
                author: 'Author'.replace(/,/g, ''),
                qr_code: 'QR Code', 
            };
        }
        

        rows.unshift(headers);
        exportCSVFile(rows, fileName); 
    }
 
    /*     download=()=>{
        const pdfArray=[
            {
                index:'qr-code',
                data:document.getElementById('pdfContentQRCODE'),
                imgElement:document.querySelectorAll('#pdfContentQRCODE tr img')
            } 
        ]; 
        PdfGenrate({pdfArray,filename:`${this.state.params.type}-qr-code`});  

    } */
    
    custonAction=(e)=> {
        const type=e.target.value?e.target.value:'';
        this.setState({params:{...this.state.params,type},preloader:true},()=>{
            this.fetchData();
        }); 
    }
 
    /*    make_base=(val)=>{ 
        let data=val.data;
        var size = 3;
 
        for(let i=0;i<data.length;i++){
            dataUri(data[i]['url'],(base64Img)=>{
                data[i]['dataUrl']=base64Img;
                if(data.length-1==i){ 
                    setTimeout(()=>{
                        var newArray = new Array(Math.ceil(data.length / size)).fill('')
                            .map(function() {
                                return this.splice(0, size); 
                            }, data.slice());
                        this.setState({pdfData:newArray,preloader:false});
                    },500);
                }
            });
        }  
    } */
 
    render() {
        let {preloader,data}=this.state; 
        return ( 
            <div> 
                <Table
                    data={data}
                    handleFetch={this.handleFetch}
                    preloader={preloader}
                    permission="qrcode-report"
                    title="QR Code Report"
                    columns={columns}
                    primaryKey="qr_code_id"
                    callPrint={this.callPrint}
                    download={this.download}
                    custonAction={this.custonAction}
                    CustomFilter={ CustomAction }
                    CustomButton={CustomButton}
                /> 
            </div>
        );
    }
}
export default Reports;


// WEBPACK FOOTER //
// ./src/components/Reports/QrCodeReport/qrcodeReport.js